import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import SafeJSON from 'modules/core/lib/SafeJSON'
import SafeLocalStorage from 'modules/core/lib/SafeLocalStorage'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { SHIFT_CONFLICTS } from 'modules/shift_management/hooks/reducers/filter'
import { usePagination } from 'modules/shift_management/hooks/usePagination'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { useUI } from 'modules/shift_management/hooks/useUI'
import Api from 'modules/shift_management/lib/Api'

import { trackOrderEmployees } from '../lib/trackEvents'
import { useEnabledFeatures } from './useEnabledFeatures'
import { useFilters } from './useFilters'
import { useShiftsRows } from './useShiftsRows'

const trackOrderEvent = (orderBy: string, orderDir: string) => {
  trackOrderEmployees(orderBy, orderDir)
}

const useOrderEmployees = (contractVersions: ContractVersions) => {
  const [, dispatchShiftsRows] = useShiftsRows()
  const [, dispatchPagination] = usePagination()
  const [filters] = useFilters()
  const [{ view }] = useSchedule()
  const [features] = useEnabledFeatures()
  const [, dispatchUI] = useUI()

  const page = filters.status_id === SHIFT_CONFLICTS ? null : 1
  const { startAt, endAt, groupType } = view

  const onOrderEmployees = async (orderBy: string, orderDir: string) => {
    trackOrderEvent(orderBy, orderDir)

    dispatchPagination({ type: 'RESET_PAGINATION' })

    dispatchUI({ type: 'LOADING' })

    const { shiftsRows: newShiftsRows } = await Api.fetch(
      {
        page,
        startAt,
        endAt,
        filters,
        groupType,
        features,
        orderBy,
        orderDir,
      },
      contractVersions
    )

    dispatchShiftsRows({
      type: 'ORDER_SHIFTS_ROWS',
      shiftsRows: newShiftsRows,
    })

    dispatchUI({ type: 'NOT_LOADING' })
  }
  return { onOrderEmployees }
}

const useOrderOptions = () => {
  const localStorageKeyOrderEmployeesBy = LOCAL_STORAGE_KEYS.orderEmployeesShiftManagementBy
  const localStorageKeyOrderEmployeesDir = LOCAL_STORAGE_KEYS.orderEmployeesShiftManagementDir

  const localStorageOrderEmployeesBy = SafeJSON.parse(
    SafeLocalStorage.getItem(localStorageKeyOrderEmployeesBy, null),
    null
  )
  const localStorageOrderEmployeesDir = SafeJSON.parse(
    SafeLocalStorage.getItem(localStorageKeyOrderEmployeesDir, null),
    null
  )

  return {
    localStorageOrderEmployeesBy,
    localStorageOrderEmployeesDir,
  }
}

export { useOrderEmployees, useOrderOptions }
